import AddToCartIcon from "./AddToCartIcon";
import { LoadingSpinner } from "./LoadingSpinner";
import { CartConfigType } from "../types/types";

export const AddToCartButton = ({
  loading,
  disabled,
  inStock,
  onClick,
  cartConfig,
}: {
  loading: boolean;
  disabled: boolean;
  inStock: boolean;
  onClick: () => void;
  cartConfig: CartConfigType;
}) => {
  return (
    <div className="flex justify-center items-center">
      <button
        disabled={disabled}
        style={{
          border: "1px solid lightgray",
          borderRadius: 10,
        }}
        onClick={onClick}
      >
        <div className="p-1 flex justify-center items-center" style={{ width: 30, height: 30 }}>
          {loading ? <LoadingSpinner /> : <AddToCartIcon tint={inStock ? cartConfig.cartInStockColor : cartConfig.cartOutOfStockColor} />}
        </div>
      </button>
    </div>
  );
};
